<div class="call-icon" [ngClass]="{
        'call-icon-pulse': !isConnected && !callEnded && !callFailed && !callRejected
      }">

  @if (callFailed || callRejected) {
    <ion-icon @iconChange src="./assets/icon/call-failed.svg"></ion-icon>
  }


  @if (callEnded && !callFailed && !callRejected) {
    <ion-icon @iconChange src="./assets/icon/call-ended.svg"></ion-icon>
  }


  @if (isConnected && !callEnded && !callFailed && !callRejected) {
    <ion-icon @iconChange src="./assets/icon/call-active.svg"></ion-icon>
  }


  @if (!isConnected && !callEnded && !callFailed && !callRejected) {
    <ion-icon @iconChange src="./assets/icon/call-ringing.svg"></ion-icon>
  }
</div>


<div class="divider"></div>


<div class="status">
  <h2 style="white-space: break-spaces;">{{ callStatus }}</h2>
</div>


@if (isConnected || (callEnded && callWasConnected)) {
  <div class="timer">
    <h2 class="timer-text">{{ callDuration }}</h2>
  </div>
}


@if (callEnded) {
  <div class="ok-button">
    <ion-button (click)="closeModal()">OK</ion-button>
  </div>
}
